import { Link as MuiLink } from "@mui/material";
import { forwardRef } from "react";
import { Link, To } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

interface CustomLinkProps {
  to: To;
  [key: string]: unknown;
}

export const InternalLink = forwardRef<HTMLAnchorElement, CustomLinkProps>(
  function InternalLink(props, ref) {
    const { isAuthenticated } = useAuth();
    // eslint-disable-next-line prefer-const
    let { to, ...rest } = props;

    if (props.restricted) {
      if (!isAuthenticated) {
        window.localStorage.setItem("postLoginUrl", document.location.href);
        to = "/login";
        delete rest.onClick;
        delete rest.restricted;
      } else {
        delete rest.restricted;
      }
    }

    return <MuiLink component={Link} ref={ref} {...rest} to={to as string} />;
  }
);
